import React from "react";
import { CellContext } from "@tanstack/react-table";
import { RowExpansion } from "@design-system/ViewTable/RowExpansion";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { GLViewRow } from "../glViewTypes";
import { JournalLineBalanceCell } from "./JournalLineCells";

export const GLBalanceCell = ({
    row,
}: Readonly<
    CellContext<ViewTableFeatures, GLViewRow, unknown>
>): React.ReactElement => {
    const { rowKind, closingBalance, balanceValue, transaction } = row.original;

    if (rowKind === "account") {
        return (
            <RowExpansion row={row}>
                {(isExpanded) =>
                    isExpanded ? (
                        <ViewTableCell />
                    ) : (
                        <JournalLineBalanceCell
                            kind="group"
                            amount={closingBalance ?? 0}
                        />
                    )
                }
            </RowExpansion>
        );
    }
    if (rowKind === "openingBalance" || rowKind === "closingBalance") {
        return (
            <JournalLineBalanceCell kind={rowKind} amount={balanceValue ?? 0} />
        );
    }
    if (rowKind === "transaction" && transaction) {
        return (
            <JournalLineBalanceCell
                kind="transaction"
                amount={transaction.balance}
            />
        );
    }
    return <ViewTableCell />;
};
